import CountryList from "country-list-with-dial-code-and-flag";

const CountryCodeAndFlag = () => {
  return CountryList?.getAll()?.map((data) => {
    return data.data;
  });
};

export default CountryCodeAndFlag;
